import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Timer } from '../timer.interface';

@Component( {
  selector: 'app-orders-list-timer',
  templateUrl: './orders-list-timer.component.html',
  styleUrls: ['./orders-list-timer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
} )
export class OrdersListTimerComponent implements OnInit, OnChanges, OnDestroy {

  @Input() status: String;
  @Input() orderTime: Date;
  @Input() searchTime: Date;
  @Input() timeLeft = 0;
  totalTimeView = 0;
  init = false;
  fullTime: Timer;
  color = '#f2f2f2';
  bgColor = '#c0c0c0';
  width = 100;

  constructor (  ) {}

  @Input()set totalTime ( data ) { this.totalTimeView = Math.round( data ); }

  ngOnChanges () {
    if ( this.init ) {
      this.checkTime();
    }
  }

  ngOnInit () {
    this.orderTime = new Date( this.orderTime );
    this.fullTime = {
      m: 0,
      s: 0
    };
    this.checkTime();
    this.init = true;
  }

  ngOnDestroy () {}

  checkTime ( flag? ) {
    let time = (this.timeLeft) / 1000;
    this.fullTime = {
      // h: Math.floor( time / 3600 ),
      m: Math.floor( time / 60 ),
      s: Math.floor( time ) % 60
    };


    if ( time >= 0 ) {
      if ( this.fullTime.m > this.totalTimeView ) {
        this.totalTimeView = this.fullTime.m;
      }
      if ( this.fullTime.m === 0 ) {
        this.bgColor = this.color = 'red';
        this.width = 0;
        return;
      } else if ( this.fullTime.m <= (this.totalTimeView - (this.totalTimeView - 2)) && this.fullTime.m != 0 ) {
        this.bgColor = this.color = 'orange';
        this.width = Math.floor( (this.fullTime.m / this.totalTimeView ) * 100 );
      } else {
        this.width = Math.floor( (this.fullTime.m / this.totalTimeView ) * 100 );
        this.bgColor = '#c0c0c0';
        this.color = '#f2f2f2';
      }
    } else {
      this.bgColor = this.color = 'red';
      this.width = 100;
      if ( flag ) {
        this.fullTime.m *= -1;
      }
    }
  }

  /*setReserve () {
    this.fullTime = {
      // h: 3,
      m: 59,
      s: 0
    };
    this.color = '#f2f2f2';
    this.width = 100;
  }*/

  /*chackStatus () {
   this.checkTime( true );
   switch ( this.status ) {
   case 'notAssigned':
   if ( this.timeLeft < 0 ) {
   this.timeLeft /= 10;
   }
   this.checkTime();
   break;
   case 'assigned':
   this.checkTime(true);
   break;
   case 'waiting':
   this.checkTime(true);
   break;
   case 'inProcess':
   this.checkTime(true);
   break;
   case 'reserved' :
   this.checkTime(true);
   break;
   default:
   // console.log( 'unknown status' );
   }
   }*/

}



// WEBPACK FOOTER //
// ./src/app/dashboard/orders-list-timer/orders-list-timer.component.ts